export default __webpack_public_path__ + "static/media/NuestroEquipo_Icon.ece7a14a.svg";